@let notificationItem = notification();

<flx-workspace-env-type-tag
  [envType]="notificationItem.workspaceType"
  [name]="notificationItem.workspaceType"
  data-testid="notification-env-tag"
  size="small"
/>

<div class="flex items-center min-w-0 gap-1 text-[11px]/4 text-neutral-500">
  <div
    [pTooltip]="notificationItem.workspaceName"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [showOnEllipsis]="true"
    class="flex-1 max-w-fit truncate"
    data-testid="notification-workspace-name"
    tooltipPosition="top"
    tooltipStyleClass="flx-prime-tooltip"
    tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
  >
    {{ notificationItem.workspaceName }}
  </div>
  /
  <div
    [pTooltip]="notificationItem.appName"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [showOnEllipsis]="true"
    class="flex-1 max-w-fit truncate"
    data-testid="notification-application-name"
    tooltipPosition="top"
    tooltipStyleClass="flx-prime-tooltip"
    tooltipZIndex="{{ TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX }}"
  >
    {{ notificationItem.appName }}
  </div>
</div>
